import { Card } from 'antd';
import TagComponent from 'components/Tags';
import TaskInfo from 'components/TaskInfo';
import { useTranslation } from 'react-i18next';
import { SelectTaskData } from 'screens/sales-group-progress';
import { getStatusValues, renderDate, renderInfoValue } from 'utils/helpers';

const HarvestContent = ({ data }: { data: SelectTaskData }) => {
  const { season, task } = { ...data };
  const { status, inputDate: completionDate } = { ...task };
  const { totalYield, sellingPrice, estimatedEndDate, actualEndDate } = {
    ...season,
  };
  const { text: iconText, color: iconColor } = getStatusValues(status);

  const { t } = useTranslation();

  const cardData = [
    {
      header: t('farmerGroupList.seasonStatus'),
      renderValue: () => <TagComponent label={iconText} color={iconColor} />,
    },
    {
      header: t('seasonProgressBar.estimatedHarvestDate'),
      renderValue: () => renderDate(estimatedEndDate),
    },
    {
      header: t('harvestPage.actualHarvestDate'),
      renderValue: () => renderDate(actualEndDate),
    },
    {
      header: t('harvestPage.totalYieldKg'),
      renderValue: () => renderInfoValue(totalYield),
    },
    {
      header: t('harvestPage.sellingPrice'),
      renderValue: () => renderInfoValue(sellingPrice),
    },
    {
      header: t('dashboard.taskCompletionDate'),
      renderValue: () => renderDate(completionDate),
    },
  ];

  return (
    <Card>
      <div className="info-container">
        {cardData.map((item, index) => (
          <TaskInfo key={index} {...item} />
        ))}
      </div>
    </Card>
  );
};

export default HarvestContent;
